// ** React Imports
import { lazy } from 'react'
import Setup from './Setup';
import Report from './Report';
import Entry from './Entry';
const Dashboard = lazy(() => import('../../../views/App/Dashboard/index'))

const AppRoutes = [
  {
    element: <Dashboard />,
    path: "/DashBoard",
    meta: {
      action: "read",
      resource: "DASH",
    },
  },
  ...Entry,
  ...Setup,
  ...Report,
];

export default AppRoutes
